import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_MUTUAL',
  title: 'Mon client n’est pas adhérent, peut-il récupérer mon dossier ?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Le but de la plateforme est de vous permettre de déposer vos documents une seule fois pour que l’ensemble de votre réseau y accède. En tant qu’adhérent, vous permettez à votre réseau d’accéder à vos documents gratuitement même s’ils ne sont pas présents sur Attestation Légale.'
  }]
};
